<div
  [innerHTML]="component.config.stepNoticeText | bindTemplate:response.data"
  class="flows-intake-step-notice"
>
</div>
